const roundNumber = ({ num, sf }: { num: number | null; sf: number }) => {
    // Round to particular level of significant figures, and then use Number()
    // to ensure there is no scientific notation
    // Return null if null or undefined or non-numeric input.
    return num === null || !num.toPrecision ? null : Number(num.toPrecision(sf));
};

export default roundNumber;
